import { Component, OnInit, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AppService } from "src/_services/app.service";
import { BetConfig, ConfigModalData } from "../../../_models/index";
import { Partner } from "src/_models/partner";
import { Role } from "src/_models/user";

@Component({
  selector: "dialog-data-example-dialog",
  templateUrl: "./common-dialog.component.html",
  styleUrls: ["./common-dialog.component.scss"],
})
export class CommonModalComponent implements OnInit {
  displayColumns: string[] = [
    "OperatorId",
    "OperatorName",
    "partnerId",
    "OperatorStatus",
  ];

  userInfo: any = JSON.parse(sessionStorage.getItem("currentUser"));
  modalData: ConfigModalData;
  ConfigData: any = null;
  btnDisable = true;
  OperatorId: "";
  SportId: "";
  CompetitionId: "";
  EventId: "";
  code: number = 1;
  ConfigCall: "";
  ProviderId: "";
  page: "";
  providerInfoForm: FormGroup;
  pageLooading = false;
  configData: BetConfig;
  partnersList: Partner[];
  selectedPartnerId: Partner;
  delaySecoundsList = [0, 1000, 2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000];
  PartnerId = "";
  setConfigInfo = false;
  groupedArray: any[] = [];
  constructor(
    public dialogRef: MatDialogRef<CommonModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private appService: AppService,
    private fb: FormBuilder
  ) {
    this.modalData = data;
    this.ConfigData = data.ConfigData;
    this.OperatorId = data.OperatorId;
    this.ConfigCall = data.ConfigCall;
    this.ProviderId = data.ProviderId;
    this.CompetitionId = data.CompetitionId;
    this.EventId = data.EventId;
    this.page = data.page;
    this.SportId = data.SportId;
    this.code = data.code;
    this.PartnerId = data.PartnerId;

    console.log(this.modalData);
  }

  ngOnInit() {
    this.getFormBuilder();
    switch (this.code) {
      case 0:
        break;
      default:
        if (this.userInfo && (this.userInfo.role === Role.SAPAdmin || this.userInfo.role === Role.RiskAdmin)) {
          this.getConfigInfo();
        } else {
          this.getCurrences(this.OperatorId);
        }
    }
    if (this.data.For ==="SAP" && (this.data.level === 'competition' || this.data.level === 'event')) {
      this.groupData();
    }
  }

  groupData(): void {
    const groupedData = this.data.providersStatus.filteredData.reduce((acc: any, item: any) => {
      // console.log("qwertyhj",item)
      if (item.group == "") {
        item.group = "OTHER"
      }
      const groupName = item.group;
      
      if (!acc[groupName]) {
        acc[groupName] = {
          items: [],
          isActive: true
        };
      }
      
      acc[groupName].items.push(item);
      
      if (item.isActive !== 'ACTIVE') {
        acc[groupName].isActive = false;
      }
      
      return acc;
    }, {});

    this.groupedArray = Object.keys(groupedData).map(groupName => ({
      group: groupName,
      items: groupedData[groupName].items,
      isActive: groupedData[groupName].isActive ? 'ACTIVE' : 'BLOCKED'
    }));
  }

  getFormBuilder() {
    this.providerInfoForm = this.fb.group({
      hold: [[Validators.required, Validators.min(0), Validators.max(100)]],
      matchOdds: this.fb.group({
        min: [0, [Validators.required, Validators.min(0)]],
        max: [1, [Validators.required, Validators.min(1)]],
        delay: [0, [Validators.required, Validators.min(0)]],
        oddLimits: [
          1,
          [Validators.required, Validators.min(0), Validators.max(100)],
        ],
      }),
      bookmaker: this.fb.group({
        min: [0, [Validators.required, Validators.min(0)]],
        max: [1, [Validators.required, Validators.min(1)]],
        delay: [0, [Validators.required, Validators.min(0)]],
      }),
      fancy: this.fb.group({
        min: [0, [Validators.required, Validators.min(0)]],
        max: [1, [Validators.required, Validators.min(1)]],
        delay: [0, [Validators.required, Validators.min(0)]],
      }),
    });
  }

  setFormDetails(betConfig: BetConfig) {
    this.providerInfoForm.controls["hold"].setValue(betConfig.hold);

    this.providerInfoForm.controls["matchOdds"]
      .get("min")
      .setValue(betConfig.matchOdds.min);
    this.providerInfoForm.controls["matchOdds"]
      .get("max")
      .setValue(betConfig.matchOdds.max);
    this.providerInfoForm.controls["matchOdds"]
      .get("delay")
      .setValue(betConfig.matchOdds.delay);
    this.providerInfoForm.controls["matchOdds"]
      .get("oddLimits")
      .setValue(betConfig.matchOdds.oddLimits);

    this.providerInfoForm.controls["bookmaker"]
      .get("min")
      .setValue(betConfig.bookmaker.min);
    this.providerInfoForm.controls["bookmaker"]
      .get("max")
      .setValue(betConfig.bookmaker.max);
    this.providerInfoForm.controls["bookmaker"]
      .get("delay")
      .setValue(betConfig.bookmaker.delay);

    this.providerInfoForm.controls["fancy"]
      .get("min")
      .setValue(betConfig.fancy.min);
    this.providerInfoForm.controls["fancy"]
      .get("max")
      .setValue(betConfig.fancy.max);
    this.providerInfoForm.controls["fancy"]
      .get("delay")
      .setValue(betConfig.fancy.delay);
  }

  async getCurrences(oid) {
    this.appService.getOpAdminCurrencies(oid).subscribe((res) => {
      if (res.status === "RS_OK") {
        this.partnersList = res.partnerIds;
        if (this.partnersList.length > 0) {
          this.selectedPartnerId = this.partnersList[0];

          this.getConfigInfo();
        }
      } else if (res.status === "RS_ERROR") {
        this.appService.openErrorBar(res.errorDescription);
      }
    });
  }

  getConfigInfo() {
    let postBody = this.modalData.apiReqBody;
    if (this.userInfo && this.userInfo.role !== Role.SAPAdmin && this.userInfo.role !== Role.RiskAdmin) {
      postBody.PartnerId = this.PartnerId
        ? this.PartnerId === "NA"
          ? ""
          : this.PartnerId
        : this.selectedPartnerId.partnerId;
    }

    this.appService.getOperatorConfigData(postBody).subscribe((res) => {
      if (res.status === "RS_OK") {
        this.configData = res.config;
        this.setConfigInfo = this.configData.isSet;
        if (
          this.configData.matchOdds.delay > 0 &&
          this.configData.matchOdds.delay < 1000
        ) {
          this.configData.matchOdds.delay = 0;
        }
        this.setFormDetails(this.configData);
      } else if (res.status === "RS_ERROR") {
        this.appService.openErrorBar(res.errorDescription);
      }
    });
  }

  toggleGroupStatus(e, group) {
    if (!(this.modalData.level === "competition" || this.modalData.level === "event")) {
      return
    }

    const operatorIds = group.items.map(item => item.OperatorId)
    console.log(this.modalData);
    let status = "BLOCKED"
    if (e.checked) {
      status = "ACTIVE"
    }
      this.appService
        .changeOperatorStatus(
          this.modalData.ProviderId,
          operatorIds,
          "",
          this.modalData.sportId,
          this.modalData.CompetitionId,
          this.modalData.EventId,
          status,
          this.modalData.level,
          group.group,
        )
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar(res.errorDescription);
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }
        });
  }
  
  handleChangeStatus(e, data) {
    console.log(this.modalData);
    if (e.checked) {
      this.appService
        .changeOperatorStatus(
          this.modalData.ProviderId,
          data.OperatorId,
          data.partnerId,
          this.modalData.sportId,
          this.modalData.CompetitionId,
          this.modalData.EventId,
          "ACTIVE",
          this.modalData.level,
          ""
        )
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar(res.errorDescription);
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }
        });
    } else {
      this.appService
        .changeOperatorStatus(
          this.modalData.ProviderId,
          data.OperatorId,
          data.partnerId,
          this.modalData.sportId,
          this.modalData.CompetitionId,
          this.modalData.EventId,
          "BLOCKED",
          this.modalData.level,
          ""
        )
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar(res.errorDescription);
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }
        });
    }
  }

  returnZero() {
    return 0;
  }

  handleSearch(event){
    const value = event.target.value;
    this.data.providersStatus.filter = value.trim().toLocaleLowerCase();
  }

  get isFromValid() {
    return this.providerInfoForm.valid;
  }

  onSubmit() {
    const bConfigForm = this.providerInfoForm.controls;
    let formData: any = {
      hold: this.providerInfoForm.controls["hold"].value,
      matchOdds: {
        min: this.providerInfoForm.get("matchOdds").get("min").value,
        max: this.providerInfoForm.get("matchOdds").get("max").value,
        delay: this.providerInfoForm.get("matchOdds").get("delay").value,
        oddLimits: this.providerInfoForm.get("matchOdds").get("oddLimits")
          .value,
      },
      bookmaker: {
        min: this.providerInfoForm.get("bookmaker").get("min").value,
        max: this.providerInfoForm.get("bookmaker").get("max").value,
        delay: this.providerInfoForm.get("bookmaker").get("delay").value,
      },
      fancy: {
        min: this.providerInfoForm.get("fancy").get("min").value,
        max: this.providerInfoForm.get("fancy").get("max").value,
        delay: this.providerInfoForm.get("fancy").get("delay").value,
      },
      isSet: this.setConfigInfo,
    };

    let partnerId = "";
    if (this.userInfo.role !== Role.SAPAdmin && this.userInfo.role !== Role.RiskAdmin) {
      if (this.selectedPartnerId) {
        partnerId = this.selectedPartnerId.partnerId;
      }

      if (this.PartnerId) {
        partnerId === "NA" ? "" : this.PartnerId;
      }
    }

    let data = {
      ConfigCall: this.page ? this.page : "",
      OperatorId: this.OperatorId ? this.OperatorId : "",
      ProviderId: this.ProviderId ? this.ProviderId : "",
      PartnerId: partnerId === "NA" ? "" : this.PartnerId,
      SportId: this.SportId ? this.SportId : "",
      CompetitionId: this.CompetitionId ? this.CompetitionId : "",
      EventId: this.EventId ? this.EventId : "",
      Config: formData,
    };

    try {
      this.appService.setOperatorConfigData(data).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.dialogRef.close();
          this.appService.openSuccessBar("data has been updated.");
        } else {
          this.appService.openErrorBar(res.errorDescription);
        }
      });
    } catch (err) {}
  }
  onPartnerChangeHandler(event: any) {}
}
